module.exports = __webpack_public_path__ + "static/img/ic_no_notifications.36b5652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ic_no_notifications.png
// module id = 252
// module chunks = 0